routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider) {

  $stateProvider
    .state('home.headerCore', {
      url: "headerCore",
      template: `<header-core sh-ctrl="shCtrl"></header-core>`
    });
}







export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/header-core/header-core.config.js
 **/